        /* ── Footer video: alleen tonen als video echt laadt ── */
        (function() {
            const cta = document.querySelector('.contact-cta');
            const video = cta ? cta.querySelector('.cta-bg-video') : null;
            if (!cta || !video) return;
            video.addEventListener('loadeddata', () => cta.classList.add('has-video'));
            video.addEventListener('error', () => video.remove());
            // Extra check: als source geen bestand heeft na 2s → opruimen
            setTimeout(() => {
                if (!cta.classList.contains('has-video')) video.remove();
            }, 2000);
        })();

        /* ── Abonnement: periode selectie (Maandelijks / Kwartaal) ── */
        document.querySelectorAll('.sub-pricing').forEach(pricing => {
            const options = pricing.querySelectorAll('.sub-price-option');
            const cta = pricing.querySelector('.cta-main');
            options.forEach(opt => {
                opt.addEventListener('click', () => {
                    options.forEach(o => o.classList.remove('active'));
                    opt.classList.add('active');
                    if (cta) cta.dataset.period = opt.dataset.period || '';
                });
            });
        });

        /* ── Aanvraag buttons — link to contact page with service parameter ── */
        document.querySelectorAll('.cta-main, .cta-row').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const service = btn.dataset.service;
                if (!service) return;
                sessionStorage.setItem('mbc_service', service);
                const period = btn.dataset.period;
                if (period) sessionStorage.setItem('mbc_period', period);
                const href = btn.getAttribute('href');
                if (href && !href.startsWith('#')) {
                    try {
                        const url = new URL(href, window.location.href);
                        url.searchParams.set('service', service);
                        if (period) url.searchParams.set('period', period);
                        btn.setAttribute('href', url.pathname + url.search);
                    } catch (err) {}
                }
            });
        });

        /* ── Mouse glow ── */
        document.addEventListener('mousemove', e => {
            document.querySelectorAll('.glow-wrap').forEach(el => {
                const r = el.getBoundingClientRect();
                el.style.setProperty('--gx', (e.clientX - r.left) + 'px');
                el.style.setProperty('--gy', (e.clientY - r.top) + 'px');
            });
        });

        const glowStyle = document.createElement('style');
        glowStyle.textContent = `.glow-wrap::before { left: var(--gx); top: var(--gy); }`;
        document.head.appendChild(glowStyle);

        /* ── Scroll-driven animations (translate, not fade) ── */
        const sections = document.querySelectorAll('.section-wrapper');
        function lerp(a, b, t) { return a + (b - a) * t; }
        function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

        function onScroll() {
            const vh = window.innerHeight;

            sections.forEach(section => {
                const rect = section.getBoundingClientRect();
                const sH = section.offsetHeight;
                const scrolled = -rect.top;
                // 0 = just entered, 1 = fully scrolled through
                const progress = clamp(scrolled / (sH - vh), 0, 1);

                // Progress bar
                const bar = section.querySelector('.scroll-progress');
                if (bar) bar.style.width = (progress * 100) + '%';

                // Image: starts fullscreen, gradient fades in as you scroll
                const imgWrap = section.querySelector('.card-image');
                const imgs = section.querySelectorAll('.card-image img');
                if (imgs.length && imgWrap) {
                    const imgY = progress * -50;
                    const scale = lerp(1.08, 1, clamp(progress * 2.5, 0, 1));
                    imgs.forEach(img => {
                        img.style.transform = `translateY(${imgY}px) scale(${scale})`;
                    });
                }

                // Content elements: scroll-driven translateY
                // Each element starts lower and scrolls into place as you scroll
                // Content: snelle fade-in zodat alles zichtbaar is voordat volgende sectie erover schuift
                const els = section.querySelectorAll('.anim-el');
                els.forEach((el, i) => {
                    const triggerStart = i * 0.015;
                    const elProgress = clamp((progress - triggerStart) / 0.06, 0, 1);
                    const ty = 20 * (1 - elProgress);
                    el.style.transform = `translateY(${ty}px)`;
                    el.style.opacity = elProgress;
                });

                // Geen exit — kaart blijft staan, volgende schuift er overheen
            });
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        requestAnimationFrame(onScroll);
